import { Link } from 'react-router-dom';

import { LifeDocumentIntroHeader } from '..';
import { Button } from '../../components/basic-inputs/button';

export function AdminPanel() {
  return (
    <div className="admin-panel-page screen">
      <LifeDocumentIntroHeader
        icon="description"
        title="Admin Panel"
        description="Manage videos and articles."
      />
      <Link to="/admin/videos">
        <Button fullWidth>Manage Videos</Button>
      </Link>
      <Link to="/admin/articles">
        <Button fullWidth>Manage Articles</Button>
      </Link>
    </div>
  );
}